import React, { useRef, useEffect } from 'react';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Project } from '../Project/Project';
import { ProjectContainerVM } from './ProjectContainerVM';
import stores from '../../../models/Stores';
import { CreateProject } from '../CreateProject';
import { ProjectsLibrary } from '../ProjectsLibrary';
import { LoadingSpinner } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import './ProjectContainer.scss';

const libraryStore = stores.AppStore.projectsLibraryStore;

const ProjectContainerComponent = () => {
  const history = useHistory();
  const vmRef = useRef<ProjectContainerVM>();
  if (!vmRef.current) {
    vmRef.current = new ProjectContainerVM(history);
  }
  const vm = vmRef.current;
  const { path } = useRouteMatch();

  useEffect(() => {
    vm.initProjectContainer();
  }, []);

  return (
    <>
      {libraryStore.isLoading && (
        <LoadingSpinner
          message={libraryStore.loadingMsg}
          loading={libraryStore.isLoading}
          className="projects-loader"
        />
      )}
      <Switch>
        <Route exact path={`${path}/new-project`}>
          <CreateProject projectClassId={stores.AppStore.createProjectClassId} />
        </Route>

        <Route exact path={[path, `${path}/page/:pageNumber?`]}>
          <ProjectsLibrary />
        </Route>

        <Route exact path={`${path}/:routeProjectId`}>
          <Project />
        </Route>
      </Switch>
    </>
  );
};

export const ProjectContainer = observer(ProjectContainerComponent);
